import { create } from 'zustand';

interface AuthState {
  token: string | null;
  staffName: string | null;
  staffRole: string | null;
  kioskId: string | null;
  setAuth: (token: string, name: string, role: string, kioskId: string) => void;
  clearAuth: () => void;
}

const STORAGE_KEY = 'kiosk_staff_token';
const STORAGE_NAME = 'kiosk_staff_name';
const STORAGE_ROLE = 'kiosk_staff_role';
const STORAGE_ID = 'kiosk_staff_id';

export const useAuthStore = create<AuthState>((set) => ({
  token: localStorage.getItem(STORAGE_KEY),
  staffName: localStorage.getItem(STORAGE_NAME),
  staffRole: localStorage.getItem(STORAGE_ROLE),
  kioskId: localStorage.getItem(STORAGE_ID),

  setAuth: (token, name, role, kioskId) => {
    localStorage.setItem(STORAGE_KEY, token);
    localStorage.setItem(STORAGE_NAME, name);
    localStorage.setItem(STORAGE_ROLE, role);
    localStorage.setItem(STORAGE_ID, kioskId);
    set({ token, staffName: name, staffRole: role, kioskId });
  },

  clearAuth: () => {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(STORAGE_NAME);
    localStorage.removeItem(STORAGE_ROLE);
    localStorage.removeItem(STORAGE_ID);
    set({ token: null, staffName: null, staffRole: null, kioskId: null });
  },
}));
